<template>
  <div :class="'iq-sidebar  sidebar-default ' + variant">
    <div
      class="iq-sidebar-logo d-flex align-items-center justify-content-between"
    >
      <a href="/" class="header-logo">
        <img
          src="@/assets/images/favicon.png"
          class="img-fluid rounded-normal light-logo"
          alt="logo"
        />
        <img
          src="@/assets/images/logo-dark.png"
          class="img-fluid rounded-normal d-none sidebar-light-img"
          alt="logo"
        />
        <span>MySyara</span>
      </a>
      <div class="side-menu-bt-sidebar-1">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="text-light wrapper-menu"
          width="30"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          @click="miniSidebar"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </div>
    </div>
    <div class="data-scrollbar" data-scroll="1" id="sidebar-scrollbar">
      <nav class="iq-sidebar-menu">
        <ul id="iq-sidebar-toggle" class="side-menu">
        
          <li class="px-3 pt-3 pb-2">
            <span class="text-uppercase small font-weight-bold"
              >Parts</span
            >
          </li>
            <li
            :class="
              checkActive('my-rfps') ? 'sidebar-layout active' : 'sidebar-layout'
            "
            title="All RFPs"
          >
            <router-link :to="{ name: 'my-rfps' }" class="svg-icon">
              <i class="">
                <svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" version="1.1" width="18" fill="none" viewBox="0 0 14 14" id="svg2" stroke="#8F9FBC">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <metadata id="metadata8"> <rdf:rdf> <cc:work rdf:about=""> <dc:format>image/svg+xml</dc:format> <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"></dc:type> <dc:title></dc:title> </cc:work> </rdf:rdf> </metadata> <defs id="defs6"></defs> <rect width="14" height="14" x="0" y="0" id="canvas" style="fill:none;stroke:none;visibility:hidden"></rect> <path d="m 1,1 0,2.25 3,0 L 4,1 z m 9,0 0,2.25 3,0 L 13,1 z M 0,4 0,14 14,14 14,4 z M 3,6 4,6 4,8 6,8 6,9 4,9 4,11 3,11 3,9 1,9 1,8 3,8 z m 5,2 5,0 0,1 -5,0 z" id="car-parts" style="fill:#8F9FBC;fill-opacity:1;fill-rule:nonzero;stroke:none"></path> </g></svg>
              </i>
              <span class="ml-2">All RFPs</span>
            </router-link>
          </li>
          <li
            :class="
              checkActive('rfps-not-quoted') ? 'sidebar-layout active' : 'sidebar-layout'
            "
            title="Not Quoted RFPs"
          >
            <router-link :to="{ name: 'rfps-not-quoted' }" class="svg-icon">
              <i class="">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"></path>
                </svg>
              </i>
              <span class="ml-2">Not Quoted</span>
            </router-link>
          </li>
          <li
            :class="
              checkActive('rfps-partially-quoted') ? 'sidebar-layout active' : 'sidebar-layout'
            "
            title="Partially Quoted RFPs"
          >
            <router-link :to="{ name: 'rfps-partially-quoted' }" class="svg-icon">
              <i class="">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="18" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 13h6m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                </svg>
              </i>
              <span class="ml-2">Partially Quoted</span>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { core } from "@/config/pluginInit";
export default {
  name: "SidebarStyle",
  props: {
    items: Array,
    variant: { type: String },
  },
  data() {
    return {
      userDetails: [],
      homeurl: "",
      dashboards: [
        "layout.dashboard1",
        "layout.dashboard2",
        "layout.dashboard3",
        "layout.customer",
        "layout.product",
        "layout.order",
        "layout.calendar",
      ],
      app: ["app.chat", "app.todo"],
      charts: [
        "chart.amchart",
        "chart.apexchart",
        "chart.highchart",
        "chart.morrischart",
      ],
      user: ["app.user-profile", "app.user-add", "app.user-list"],
      ui: [
        "Ui.avatars",
        "Ui.alerts",
        "Ui.badges",
        "Ui.breadcrumbs",
        "Ui.buttons",
        "Ui.button-groups",
        "Ui.boxshadows",
        "Ui.colors",
        "Ui.cards",
        "Ui.carousels",
        "Ui.grids",
        "Ui.helper-classes",
        "Ui.images",
        "Ui.list-groups",
        "Ui.media-objects",
        "Ui.modals",
        "Ui.notifications",
        "Ui.paginations",
        "Ui.popovers",
        "Ui.progressbars",
        "Ui.typographys",
        "Ui.tabs",
        "Ui.tooltips",
        "Ui.Embed-videos",
      ],
      auth: [
        "auth.login",
        "auth.register",
        "auth.recover-password",
        "auth.confirm-mail",
        "auth.lock-screen",
      ],
      pricing: ["price.pay", "price.pay2"],
      icon: [
        "icon.dripicon",
        "icon.fontawsome",
        "icon.lineawsome",
        "icon.remixicon",
      ],
      error: ["error.404", "error.500"],
      formControls: [
        "controls.form-checkbox",
        "controls.form-layout",
        "controls.form-input",
        "controls.form-radio",
        "controls.form-switch",
        "controls.form-textarea",
        "controls.form-validation",
      ],
      formWidget: [
        "widget.form-datepicker",
        "widget.form-file-uploader",
        "widget.form-quill",
      ],
      table: ["table.basic-table", "table.data-table", "table.edit-table"],
      timeline: ["time.line", "time.line1"],
      extraPages: [
        "price.pay",
        "pages.maintenance",
        "pages.comingsoon",
        "pages.invoices",
        "pages.subscribers",
        "pages.faq",
        "pages.blank-page",
        "pages.icon",
      ],
      pages: [],
      checklistSvg: require("../../../../assets/images/svg/checklist.svg"),
    };
  },
  mounted() {
    core.SmoothScrollbar();
    if (localStorage.getItem("user-details") !== null) {
      this.userDetails = JSON.parse(localStorage.getItem("user-details"));
    }
    const urlParams = new URLSearchParams(window.location.search);
    const sidebar = urlParams.get("sidebar");
    if (sidebar !== null) {
      this.variant = "";
      switch (sidebar) {
        case "0":
          this.variant = "sidebar-dark";
          break;
        case "1":
          this.variant = "sidebar-light";
          break;
        default:
          this.variant = "";
          break;
      }
    }
  },
  destroyed() {
    core.SmoothScrollbar();
  },
  computed: {
    ...mapGetters({
      logo: "darklogo",
      sidelogo: "logo",
    }),
  },
  methods: {
    checkActive(route) {
      if (this.$route.name == route) {
        return true;
      }
      if (route.includes(this.$route.name)) {
        return true;
      }
    },
    miniSidebar() {
      core.triggerSet();
    },
    showCollapse(collapseId) {
      document.getElementById(collapseId).closest("li").classList.add("active");
    },
    hideCollapse() {
      const list = document
        .querySelector(".iq-sidebar-menu")
        .querySelectorAll(".submenu");
      Array.from(list, (elem) => {
        if (
          elem.closest(".active") !== null &&
          elem.closest(".active") !== undefined
        ) {
          elem.closest(".active").classList.remove("active");
        }
      });
    },
  },
};
</script>
<style scoped>
.iq-sidebar-menu .side-menu li li.active a {
  color: #fff;
  text-decoration: none;
  background-color: rgba(255, 255, 255, 0.08);
  border-radius: 5px;
}
</style>

